// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
    key: "239c6d50d36c136a5288683ad53410f2",
  base: "https://api.openweathermap.org/data/2.5/",
};
